function fieldName(loc) {
  if (!Array.isArray(loc)) return '';
  return loc.filter(part => part !== 'body').map(part => String(part)).join('.');
}

function messageText(msg) {
  return typeof msg === 'string' ? msg.replace(/^Value error,\s*/, '') : '';
}

function entryText(item) {
  if (typeof item === 'string') return item;
  if (!item || typeof item !== 'object') return '';
  const field = fieldName(item.loc);
  const msg = messageText(item.msg) || (typeof item.message === 'string' ? item.message : '');
  if (field && msg) return `${field}: ${msg}`;
  return msg || field;
}

/** Turn a FastAPI `detail` into text a toast can render. */
export default function apiErrorDetail(detail, fallback = 'Something went wrong') {
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const lines = detail.map(entryText).filter(Boolean);
    return lines.join('; ') || fallback;
  }
  if (detail && typeof detail === 'object') {
    const direct = entryText(detail);
    if (direct) return direct;
    if (typeof detail.detail === 'string' && detail.detail.trim()) return detail.detail;
    const parts = Object.entries(detail)
      .filter(([, value]) => typeof value === 'string' && value.trim())
      .map(([key, value]) => `${key}: ${value}`);
    return parts.join('; ') || fallback;
  }
  return fallback;
}
